// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2L0Qi","col":"styles_col__Utxas"};